module.exports = __webpack_public_path__ + "img/icon_entrevista.501271d2.svg";